export default "__VITE_ASSET__BPtAD12j__"